import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'
import SimpleNailScene from '../three/SimpleNailScene'

export default function ModelShowcase() {
  return (
    <section id="technology" className="py-20 lg:py-0 bg-bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 min-h-[80vh] items-center">
          {/* 3D Model - Left Side */}
          <div className="relative h-[50vh] lg:h-[80vh] bg-bg-tertiary">
            <SimpleNailScene className="absolute inset-0" />
          </div>

          {/* Content - Right Side */}
          <div className="px-6 lg:px-16 py-16 lg:py-20">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Eyebrow */}
              <p className="text-xs uppercase tracking-[0.3em] text-text-muted mb-4">
                NFC Technology
              </p>

              {/* Headline */}
              <h2 className="text-display-md font-serif font-medium text-text-primary mb-6">
                Experience<br />
                <span className="italic">The Technology</span>
              </h2>

              {/* Description */}
              <p className="text-base text-text-secondary mb-8 max-w-md">
                Each Nakhoons nail features embedded NFC technology, allowing you to
                tap to pay, share your contact information, or link to your social
                media profiles with a simple touch.
              </p>

              {/* Features List */}
              <ul className="space-y-4 mb-10">
                {[
                  { title: 'Tap to Pay', desc: 'Make contactless payments with style' },
                  { title: 'Share Contacts', desc: 'Exchange information instantly' },
                  { title: 'Custom Actions', desc: 'Program your nails for any task' },
                ].map((feature, index) => (
                  <motion.li
                    key={feature.title}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="flex items-start gap-4"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2 flex-shrink-0" />
                    <div>
                      <h3 className="text-sm font-medium text-text-primary uppercase tracking-wider">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-text-muted mt-1">{feature.desc}</p>
                    </div>
                  </motion.li>
                ))}
              </ul>

              {/* CTA */}
              <a
                href="#products"
                className={cn(
                  'inline-flex items-center gap-2',
                  'text-sm font-medium text-primary uppercase tracking-wider',
                  'border-b border-primary pb-1',
                  'hover:opacity-70 transition-opacity duration-300'
                )}
              >
                Learn More
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}
